import { render, staticRenderFns } from "./formAccountInfo.vue?vue&type=template&id=47c1c8cf"
import script from "./formAccountInfo.vue?vue&type=script&lang=js"
export * from "./formAccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports